module.exports = __webpack_public_path__ + "media/images/header-1175dbddd30ffb0856bcb198b34f5c5c.jpg";